import { isSSR } from "./../../wix-rich-content-common/index.js";
const baseDecodedInstance = {
  instanceId: "",
  appDefId: "",
  metaSiteId: "",
  uid: "",
  siteOwnerId: ""
};
function splitInstance(instance) {
  console.assert(instance, "instance is mandatory");
  const splitted = instance.split(".");
  console.assert(splitted.length >= 2, "instance must contain data and signature separated by .");
  const [signature, data] = splitted.slice(-2);
  return { data, signature };
}
function parseInstance(instance) {
  if (!instance) {
    return baseDecodedInstance;
  }
  const { data } = splitInstance(instance);
  const bit64Data = isSSR() ? (
    // Accessing 'Buffer' via 'global' prevents webpack polyfilling it for web environment
    global.Buffer.from(data, "base64").toString("utf8")
  ) : atob(data);
  const decodedInstance = JSON.parse(bit64Data);
  return {
    ...baseDecodedInstance,
    ...decodedInstance
  };
}
export {
  parseInstance
};
//# sourceMappingURL=parseInstance.js.map
